import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IndexedPriceEstimate } from '../hedging-view';

// Values of the formula, weighted by the unprotected consumption (the indexed price is the same for every year)
export interface IndexedPriceFormulaValues {
    averageOmip: number,
    averageProfileFactor: number,
    averageLossFactor: number,
    averageIndexedPrice: number
}

@Component({
    selector: 'app-indexed-price-formula-info',
    templateUrl: './indexed-price-formula-info.component.html',
    styleUrls: ['./indexed-price-formula-info.component.scss']
})
export class IndexedPriceFormulaInfoComponent {

    readonly IndexedPriceEstimate = IndexedPriceEstimate;

    // Tariff period coefficients, in the order they're usually presented (most to least expensive)
    readonly profileCoefficients: { labelKey: string, value: number }[] = [
        { labelKey: 'INDEXED_PRICE_PERIOD_PEAK', value: IndexedPriceEstimate.PROFILE_COEFFICIENTS.peak },
        { labelKey: 'INDEXED_PRICE_PERIOD_STANDARD', value: IndexedPriceEstimate.PROFILE_COEFFICIENTS.standard },
        { labelKey: 'INDEXED_PRICE_PERIOD_OFF_PEAK', value: IndexedPriceEstimate.PROFILE_COEFFICIENTS.offPeak },
        { labelKey: 'INDEXED_PRICE_PERIOD_SUPER_OFF_PEAK', value: IndexedPriceEstimate.PROFILE_COEFFICIENTS.superOffPeak }
    ];

    readonly lossFactors: { tensionLevel: string, value: number }[] = Object.entries(IndexedPriceEstimate.LOSS_FACTORS_BY_TENSION_LEVEL)
        .map(([tensionLevel, value]) => ({ tensionLevel, value }));

    formulaValues?: IndexedPriceFormulaValues;

    constructor(
        private readonly dialogRef: MatDialogRef<IndexedPriceFormulaInfoComponent>,
        @Inject(MAT_DIALOG_DATA) data: { formulaValues?: IndexedPriceFormulaValues }
    ) {
        this.formulaValues = data?.formulaValues;
    }

    close() {
        this.dialogRef.close();
    }
}
